import { useBuild } from "~/components/build/Show/lib/BuildContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from "~/components/shared/DropdownMenu";
import Icon from "~/components/shared/Icon";
import { twMerge } from "tailwind-merge";

export function PipelineSettings(props: { className?: string }) {
  const { build } = useBuild();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        title="Pipeline settings"
        className={twMerge(
          "flex h-6 w-6 items-center justify-center self-center rounded-sm outline-none hover:bg-gray-200",
          props.className,
        )}
      >
        <Icon icon="down-triangle" className="h-2 w-2 flex-none" />
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent>
          <DropdownMenuItem asChild={true}>
            <DropdownLink href={`${build.project.url}/settings`}>Settings</DropdownLink>
          </DropdownMenuItem>
          <DropdownMenuItem asChild={true}>
            <DropdownLink href={`${build.project.url}/settings/steps`}>Edit steps</DropdownLink>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}

const DropdownLink = ({ href, children, ...props }) => (
  <a href={href} className="grow text-inherit hover:text-inherit focus:text-inherit" {...props}>
    {children}
  </a>
);
